import { Image, ImageProps } from 'antd';
import Phantom from '@/assets/images/phantom.png';
import styles from './avatar.module.scss';

export function Avatar(props: ImageProps) {
  return (
    <Image
      width={24}
      height={24}
      {...props}
      className={styles.avatar}
      fallback={Phantom}
      preview={false}
    />
  );
}
